import { MembershipRole } from "@productlane/db/browser"

export const ROLE_OPTIONS: {
	role: MembershipRole
	label: string
	description: string
}[] = [
	{
		role: MembershipRole.ADMIN,
		label: "Admin",
		description:
			"Full control of the workspace, including billing and settings",
	},
	{
		role: MembershipRole.USER,
		label: "Member",
		description: "Can edit and reply to threads across all public teams",
	},
	{
		role: MembershipRole.VIEWER,
		label: "Viewer",
		description: "Read-only access, and the only role on a free seat",
	},
]

export function shouldPersistRoleChange(
	currentRole: MembershipRole,
	selectedRole: MembershipRole,
): boolean {
	return currentRole !== selectedRole
}

/** The server's reason when it refused the change on purpose (a plan's seat limit), otherwise a retry hint. */
export function roleChangeErrorMessage(error: unknown): string {
	const { data, message } = error as {
		data?: { code?: string }
		message?: string
	}
	return data?.code === "BAD_REQUEST" && message ? message : "Try again."
}
